// import React from "react";
// import Asset from "../../assets/images/asset.png";
// import contributionsIncome from "../../assets/images/contributions.png";
// import Savings from "../../assets/images/savings.png";
// import Debt from "../../assets/images/debt.png";
// import "./mainDashboard.css";
// import NewLoader from "../../components/styled-components/loader/NewLoader";
// export const DashboardGeneralSection = (props) => {
//   const GeneralSection = [
//     {
//       id: 1,
//       name: "Assets",
//       value:
//         props && props.monetary
//           ? props.monetary
//               .toFixed(2)
//               .toString()
//               .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
//           : 0.0,
//       icon: Asset,
//     },
//     { id: 2, name: "Income", value: "232,551.00", icon: contributionsIncome },
//     { id: 3, name: "Monthly Savings", value: "1,295.00", icon: Savings },
//     {
//       id: 4,
//       name: "Debt",
//       value:
//         props.debt
//           ? (props.debt || 0)
//               .toFixed(2)
//               .toString()
//               .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
//           : (0)
//               .toFixed(2)
//               .toString()
//               .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
//       icon: Debt,
//     },
//   ];

//   return (
//     <div className="cardsForAssets" style={{position:"relative"}}>
//       {GeneralSection &&
//         GeneralSection.map((item, index) => (
//           <div key={index} className="generalMaincards">
//             <div className="generalMaincardsInner">
//               {" "}
//               <div className="generalMainImages">
//                 <img src={item.icon} height={"40px"} alt={item.name} />{" "}
//               </div>
//               <div className="generalMainHeader">
//                 <span className="gerealheading">{item.name}</span>
//                 <span className="gerealheadingValue">${item.value}</span>
//               </div>
//             </div>
//           </div>
//         ))}
//       <NewLoader isLoading={props.loading} />
//     </div>
//   );
// };

import React, { useState, useEffect } from "react";
import Asset from "../../assets/images/asset.png";
import contributionsIncome from "../../assets/images/contributions.png";
import Savings from "../../assets/images/savings.png";
import Debt from "../../assets/images/debt.png";
import { HorizontalBar } from "react-chartjs-2";
import "./mainDashboard.css";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import DASHBOARD_API from "../../apis/dashboard.api";
import { MODULE_API } from "../../apis";
import moment from "moment";
import { useTheme } from "../../utils/ThemeContext";

export const DashboardGeneralSection = (props) => {
  const { theme } = useTheme();

  const [monetaryValue, setMonetaryValue] = useState(0);
  const [monetaryValueCollection, setMonetaryValueCollection] = useState(0);
  const [monetaryValueInventory, setMonetaryValueInventory] = useState(0);
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [yearlyDataReport, setYearlyDataReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const GeneralSection = [
    {
      id: 1,
      name: "Assets",
      value: (
        +monetaryValue +
        +monetaryValueCollection +
        +monetaryValueInventory
      )
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      icon: Asset,
    },
    {
      id: 2,
      name: "Income",
      value:
        yearlyDataReport &&
        yearlyDataReport.totalYearly &&
        yearlyDataReport.totalYearly
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      icon: contributionsIncome,
    },
    { id: 3, name: "Monthly Savings", value: "1,295.00", icon: Savings },
    {
      id: 4,
      name: "Debt",
      value:
        (totalLoan || totalBalance) &&
        (parseFloat(totalLoan) + parseFloat(totalBalance))
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      icon: Debt,
    },
  ];
  const getMonetaryValueAssets = async () => {
    try {
      setLoading(true);
      setMonetaryValueInventory(0);
      const moduleName = "Assets";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (data && data.data && data.data[0] && data.data[0].monetary) {
        setMonetaryValue(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getMonetaryValueInventory = async () => {
    try {
      setLoading(true);
      setMonetaryValueInventory(0);
      const moduleName = "Property";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (data && data.data && data.data[0] && data.data[0].monetary) {
        setMonetaryValueInventory(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getMonetaryValueCollection = async () => {
    try {
      setLoading(true);
      setMonetaryValueCollection(0);
      const moduleName = "Collection";
      let data = await DASHBOARD_API.fetchMonetaryValueofModule(moduleName);
      if (data && data.data && data.data[0] && data.data[0].monetary) {
        setMonetaryValueCollection(data.data[0].monetary);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getAll = async () => {
    await getMonetaryValueAssets();
    await getMonetaryValueCollection();
    await getMonetaryValueInventory();
    await getIncomeTotalYearly();
    await getLiabilitySum();
    await getCreditSum();
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getCreditSum = async () => {
    try {
      setLoading(true);
      setTotalBalance(0);
      let data = await MODULE_API.fetchLiabilitySum("Credit");
      if (data && data.sum) {
        setTotalBalance(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getIncomeTotalYearly = async () => {
    try {
      setLoading(true);
      const currentDate = moment();
      const startDate = currentDate
        .clone()
        .startOf("year")
        .format("YYYY-MM-DD");
      const endDate = currentDate.clone().endOf("month").format("YYYY-MM-DD");
      // const endDate = currentDate.clone().endOf("year").format("YYYY-MM-DD");
      let datares = await MODULE_API.fetchIncomeSum(startDate, endDate);
      if (datares && datares.data) {
        const yearlyData = datares.data;
        let yearlyResponse = {
          ...datares.data,
          totalYearly: yearlyData
            ? (+yearlyData.Active || 0) + (+yearlyData.Passive || 0)
            : 0,
        };
        setYearlyDataReport(yearlyResponse);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getAll();
  }, []);
  const totalAssetValue =
    +monetaryValue + +monetaryValueCollection + +monetaryValueInventory;
  const totalDebtValue =
    (totalLoan || totalBalance) &&
    parseFloat(totalLoan) + parseFloat(totalBalance);

  const netAmount = totalAssetValue - totalDebtValue;

  const chartData = {
    labels: ["Account Balance"],
    datasets: [
      {
        label: "Assets",
        data: [parseFloat(totalAssetValue).toFixed(2)],
        backgroundColor: ["#09A84D"],
      },
      {
        label: "Debts",
        data: [parseFloat(totalDebtValue).toFixed(2)],
        backgroundColor: ["#E53E3E"],
      },
      {
        label: "Net Worth",
        data: [parseFloat(netAmount).toFixed(2)],
        backgroundColor: ["#2A3DA3"],
      },
    ],
  };
  const options = {
    plugins: {
      datalabels: {
        display: false, // We’ll handle the text rendering manually
      },
    },
    legend: {
      position: "bottom",
    },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      xAxes: [
        {
          stacked: false, // Ensure bars are stacked on the x-axis (horizontal stacking)
          gridLines: {
            color: "rgba(0, 0, 0, 0)", // Make grid lines invisible
          },
          ticks: {
            callback: function (value) {
              // Format the ticks on the x-axis as currency
              return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(value);
            },
          },
        },
      ],
      yAxes: [
        {
          stacked: false, // Stack bars vertically
          categoryPercentage: 0.5, // Reduce to decrease spacing
          barPercentage: 1,
          ticks: {
            display: false, // Hide y-axis labels
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: (tooltipItem, data) => {
          let label = data.datasets[tooltipItem.datasetIndex].label || "";
          let value =
            data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  
          return `${label}: $${parseFloat(value).toFixed(2)}`;
        },
      },
    },
    animation: {
      onComplete: function () {
        const chart = this.chart;
        const ctx = chart.ctx;
        const datasets = chart.data.datasets;
        datasets.forEach((dataset, index) => {
          ctx.fillStyle = "white"; // Text color
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";

          dataset.data.forEach((value, i) => {
            const x = chart.getDatasetMeta(index).data[i]._model.x;
            const y = chart.getDatasetMeta(index).data[i]._model.y;
            const width = chart.getDatasetMeta(index).data[i]._model.width;
            const height = chart.getDatasetMeta(index).data[i]._model.height;

            // Drawing the value on top of each bar
            ctx.fillText(
              parseFloat(value).toFixed(2), // Value to display
              x + width / 2, // X position (center of the bar)
              y + height / 2 // Y position (center of the bar)
            );
          });
        });
      },
    },
  };

  return (
    <div className="generalParent" style={{ position: "relative" }}>
      <div
        className="cardsForAssets"
        style={{
          position: "relative",
          background: theme === "light" ? "white" : "#232323",
        }}
      >
        {GeneralSection &&
          GeneralSection.map((item, index) => (
            <div
              key={index}
              className="generalMaincards"
              style={{ background: theme === "light" ? "white" : "#232323" }}
            >
              <div className="generalMaincardsInner">
                {" "}
                <div className="generalMainImages">
                  <img src={item.icon} height={"28px"} alt={item.name} />{" "}
                </div>
                <div className="generalMainHeader">
                  <span
                    className="gerealheading"
                    style={{ color: theme === "light" ? "" : "white" }}
                  >
                    {item.name}
                  </span>
                  <span
                    className="gerealheadingValue"
                    style={{ color: theme === "light" ? "" : "white" }}
                  >
                    ${item.value ? item.value : 0}
                  </span>
                </div>
              </div>
            </div>
          ))}
        <NewLoader isLoading={props.loading} />
      </div>
      <div
        className="cardAndProgressBar"
        style={{ background: theme === "light" ? "white" : "#232323" }}
      >
        <div style={{ height: "300px", display: "flex",width:"100%" }}>
          <HorizontalBar options={options} data={chartData} />
        </div>
        {/*<div
          className="generalMaincards "
          style={{ background: theme === "light" ? "white" : "#232323" }}
        >
          <div className="generalMaincardsInner">
            <div className="generalMainImages">
              <img
                src="/static/media/asset.cb8cfc4b.png"
                height="40px"
                alt="Assets"
              />
            </div>
            <div className="generalMainHeader">
              <span
                className="gerealheading"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                Net Worth
              </span>
              <span
                className="gerealheadingValue"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                $
                {netAmount
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </span>
            </div>
          </div>
        </div>
        <div
          className="progressBarSection"
          style={{ background: theme === "light" ? "white" : "#232323" }}
        >
          <div>
            <div
              className=""
              style={{
                background: "linear-gradient(-90deg, #17D368 0%, #065D2C 50%)",
              }}
            >
              <div
                className="w3-blue"
                style={{
                  height: "24px",
                  width: "70%",
                  background:
                    "linear-gradient(180deg, #2A3DA3 0%, #5D74EF 100%)",
                }}
              ></div>
            </div>
          </div>
          <div className="totalDebtTotalAssets">
            <div>
              <span
                className="gerealheading"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                Total Debt{" "}
              </span>
              <span
                className="gerealheadingValue"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                $
                {totalDebtValue
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </span>
            </div>
            <div>
              <span
                className="gerealheading"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                Total Assets{" "}
              </span>
              <span
                className="gerealheadingValue"
                style={{ color: theme === "light" ? "" : "white" }}
              >
                $
                {totalAssetValue
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
              </span>
            </div>
          </div>
        </div>*/}
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
